function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.414 7.778l4.95 4.95-1.414 1.414L0 9.192z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.142 4.95l-8.485 8.485-1.415-1.414 8.486-8.486z"
});

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "current"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNXB4IiB2aWV3Qm94PSIwIDAgMTUgMTUiIGZpbGw9ImN1cnJlbnQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEuNDE0MDYiIHk9IjcuNzc4MDgiIHdpZHRoPSI3IiBoZWlnaHQ9IjIiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDEuNDE0MDYgNy43NzgwOCkiIC8+CjxyZWN0IHg9IjE0LjE0MjEiIHk9IjQuOTQ5NzEiIHdpZHRoPSIxMiIgaGVpZ2h0PSIyIiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgMTQuMTQyMSA0Ljk0OTcxKSIgLz4KPC9zdmc+Cg==";
export { SvgCheckmark as ReactComponent };